module.exports = require("@splunk/react-ui/themes");